import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function LogsIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 15.448 13.126" {...props}>
      <path
        transform="translate(-2 -2)"
        d="M3.545,3A1.548,1.548,0,0,0,2,4.545v6.179a1.548,1.548,0,0,0,1.545,1.545H7.479L5.934,10.724H3.545V4.545H15.9v6.179H11.944l1.545,1.545H15.9a1.548,1.548,0,0,0,1.545-1.545V4.545A1.548,1.548,0,0,0,15.9,3ZM5.862,7.634V9.565l5.02,5.02,1.931-1.931L7.793,7.634Zm7.531,5.624-1.907,1.907.821.821a.477.477,0,0,0,.676,0l1.231-1.231a.477.477,0,0,0,0-.676Z"
      />
    </SvgIcon>
  );
}

export default LogsIcon;
